import { render, staticRenderFns } from "./CallPopup.vue?vue&type=template&id=af305914&"
import script from "./CallPopup.vue?vue&type=script&lang=js&"
export * from "./CallPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports